import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DxChartComponent } from 'devextreme-angular';
import { Dashboard } from '../dashboard.models';

@Component({
  selector: 'app-orders-customers-by-municipality-chart',
  templateUrl: './orders-customers-by-municipality-chart.component.html',
  styleUrls: ['./orders-customers-by-municipality-chart.component.scss']
})
export class OrdersCustomersByMunicipalityChartComponent implements OnInit {
  @ViewChild('chart', { static: false }) chart: DxChartComponent;
  @Input('dashboardData') dashboardData: Dashboard;

  constructor() { }

  ngOnInit(): void {
    this.dashboardData.data.sources = [
      { value: "orders", name: "DASHBOARD.NUMBER_OF_ORDERS", visible: false },
      { value: "customers", name: "DASHBOARD.NUMBER_OF_CUSTOMERS", visible: false },
      { value: "ordersValue", name: "DASHBOARD.ORDER_VALUE", visible: true }
    ];
  }

  ngOnChanges(changes): void {
    if(changes != null && changes.dashboardData != null) {
      this.ngOnInit();
    }
  }
  
  pointClick(e: any) {
    e.target.select();
  }

  legendClick(e: any) {
    let series = e.target;
    if (series.isVisible()) {
      series.hide();
    } else {
      series.show();
    }
  }
}
